<bdo-simple-text-popup [isVisible]="maintenanceShowPopup$ | async" (closePopupEvent)="close()"
  [isManuallyClosable]="(serviceUnavailable$ | async) !== true"
  [title]="(soonUnderMaintenance ? 'maintenance.soon.title' : 'maintenance.now.title') | translate"
  [icon]="'error'">

  @if (soonUnderMaintenance) {
    <div>
      <div class="re-copytext-with-margin">
        <p>{{ 'maintenance.soon.subtitle' | translate }}</p>
        <p class="re-mb-30">{{ 'maintenance.soon.description' | translate }}</p>
        <p class="bold re-mb-30">{{start | date:'dd.MM.yyyy HH:mm'}} Uhr - {{end | date:'dd.MM.yyyy HH:mm'}} Uhr</p>
        <p>{{infoText}}</p>
      </div>
      <button class="bdo-button-primary" (click)="close()">{{ 'general.action.close' | translate }}</button>
    </div>
  } @else {
    <p [innerHTML]="'maintenance.now.description' | translate" class="re-copytext-with-margin"></p>
    <a class="bdo-button-primary" [href]="reBaseData.hrefContactForm">
      {{ 'general.navigation.linkContactForm' | translate }}
    </a>
  }


</bdo-simple-text-popup>
